<template>
    <b-badge class='t-badge' :style='style' @click="$emit('click')"><slot></slot></b-badge>
</template>

<script>

export default {
  name: 't-badge',
  props: {
    background: { default: null },
    color: { default: null },
    clickable: { type: Boolean, default: false },
  },
  computed: {
    style(){ 
      let css = "";
      if(this.color) css += "color: " + this.color + ";";
      if(this.background) css += "background-color: " + this.background + ";";
      if(this.clickable) css += "cursor: pointer;";
      return css;
    }
  }
} 

</script>


